import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, ArrowRight } from 'lucide-react';

interface NavigationButtonsProps {
  canGoBack: boolean;
  canGoNext: boolean;
  isLoading: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  canGoBack,
  canGoNext,
  isLoading,
  onPrevious,
  onNext
}) => {
  return (
    <div className="fixed bottom-6 left-0 right-0 flex justify-between items-center px-6 z-20">
      {/* Back Button */}
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={onPrevious}
        disabled={!canGoBack}
        className={`w-12 h-12 rounded-lg flex items-center justify-center transition-all duration-200 ${
          canGoBack
            ? 'text-white hover:opacity-80 cursor-pointer'
            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
        }`}
        style={{
          backgroundColor: canGoBack ? '#000000' : undefined
        }}
      >
        <ArrowLeft size={20} />
      </motion.button>


      {/* Next Button */}
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={onNext}
        disabled={!canGoNext || isLoading}
        className={`px-6 py-3 rounded-lg flex items-center space-x-2 transition-all duration-200 ${
          canGoNext && !isLoading
            ? 'text-white hover:opacity-80 cursor-pointer'
            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
        }`}
        style={{
          backgroundColor: canGoNext && !isLoading ? '#000000' : undefined
        }}
      >
        {isLoading ? (
          <div className="loading-spinner" />
        ) : (
          <>
            <span className="font-semibold">NEXT</span>
            <ArrowRight size={16} />
          </>
        )}
      </motion.button>
    </div>
  );
};
